import React from "react";
import MenuBarItemLink from "./MenuBarItemLink";
import {MenuItem} from "navigation-common/types/navigation-types";
import classNames from "classnames";

interface MenuItemComponentProps {
    menuItem: MenuItem,
    onPress: (menuItemKey: string) => void,
    activated: boolean,
    preview?: boolean,
    isSmallScreen: boolean
}

const MenuBarItem = (props: MenuItemComponentProps) => {
    const [isLvl3MenuOpen, setIsLvl3MenuOpen] = React.useState(false);


    const onToggleLvl3Menu = () => {
        setIsLvl3MenuOpen(!isLvl3MenuOpen);
    }

    return <>
        {props.menuItem.level === 1 && <li className={classNames({"active": props.activated})} key={props.menuItem.key}>
            <MenuBarItemLink key={props.menuItem.key} menuItem={props.menuItem} preview={props.preview} onPress={() => {
                props.onPress(props.activated ? "" : props.menuItem.key);
            }} activated={props.activated}/>
        </li>}

        {props.menuItem.level === 2 && <li className={classNames({"active": props.activated})} key={props.menuItem.key}>
            <MenuBarItemLink key={props.menuItem.key} menuItem={props.menuItem} preview={props.preview}
                             activated={props.activated}
                             onToggleSubMenuClicked={onToggleLvl3Menu}
                             isSubMenuOpen={isLvl3MenuOpen}/>
            {props.menuItem.subMenuItems && (!props.isSmallScreen || isLvl3MenuOpen) &&
                <ul className={"level-3"}>
                    {props.menuItem.subMenuItems.map((menuItem: MenuItem) => {
                        return <li key={menuItem.key}>
                            <MenuBarItemLink key={menuItem.key} menuItem={menuItem} preview={props.preview} activated={props.activated}/>
                        </li>
                    })}
                </ul>
            }
        </li>}
    </>;
}

export default MenuBarItem;
